// import mernImg from '../assets/Natours.png'

const WorkCard = (props) => {
  return (
    <div className="work-card">
      <div className="work-card__overlay">
        <h3 className="work-card__overlay--title">{props.title}</h3>
        { props.subtitle ? <h4 className="work-card__overlay--subtitle">{props.subtitle}</h4> : ''}
        <div className="work-card__overlay--tools">{props.tools}</div>
        <div className="work-card__overlay--links">
          {props.githubBack ? (
            <a
              className="work-card__overlay--link github-link"
              href={props.githubFront}
              target="_blank"
              rel="noreferrer"
            >
              GitHub front-end repo
            </a>
          ) : (
            <a
              className="work-card__overlay--link github-link"
              href={props.githubFront}
              target="_blank"
              rel="noreferrer"
            >
              GitHub repo
            </a>
          )}

          {props.githubBack && (
            <a
              className="work-card__overlay--link github-link"
              href={props.githubBack}
              target="_blank"
              rel="noreferrer"
            >
              GitHub back-end repo
            </a>
          )}
        </div>
        <a
          className="work-card__overlay--link site-link"
          href={props.site}
          target="_blank"
          rel="noreferrer"
        >
          Visit site
        </a>
      </div>
      <div
        className="work-card__img"
        style={{ backgroundImage: `url(${props.img})` }}
      ></div>
    </div>
  );
};

export default WorkCard;
